import React, { useState } from 'react';
import path from 'path-browserify'; // Import path
import './ImageUpload.css'; // Import the CSS file

const ImageUpload = () => {
  const [image1, setImage1] = useState(null);
  const [image2, setImage2] = useState(null);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleImage1Change = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Validate filename
      const validExtensions = ['.jpg', '.jpeg', '.png'];
      const ext = path.extname(file.name).toLowerCase();
      if (!validExtensions.includes(ext)) {
        setError('Invalid file type for Image 1. Use .jpg, .jpeg, or .png');
        setImage1(null);
        return;
      }
      setImage1(file);
      setError('');
    }
  };

  const handleImage2Change = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Validate filename
      const validExtensions = ['.jpg', '.jpeg', '.png'];
      const ext = path.extname(file.name).toLowerCase();
      if (!validExtensions.includes(ext)) {
        setError('Invalid file type for Image 2. Use .jpg, .jpeg, or .png');
        setImage2(null);
        return;
      }
      setImage2(file);
      setError('');
    }
  };

  const handleSubmit = async () => {
    const formData = new FormData();
    if (image1) {
      formData.append('image1', image1, `image1${path.extname(image1.name)}`);
    }
    if (image2) {
      formData.append('image2', image2, `image2${path.extname(image2.name)}`);
    }

    try {
      const token = localStorage.getItem('token');
      const response = await fetch('/api/upload', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`
        },
        body: formData
      });

      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.error || 'Upload failed');
      }

      setMessage(data.message || 'Upload successful!');
      setImage1(null);
      setImage2(null);
      setError('');
    } catch (err) {
      setError(err.message || 'Upload failed.');
    }
  };

  return (
    <div className="form-container">
      <h2>HIFI-Setups Foto-Upload</h2>
      <p>BEACHTEN: es sind max. 2 Bilder Deines Hifi-Setups erlaubt und eine Gesamtgröße von max. 50Mb für beide Bilder.</p> <p><b>!! WICHTIG: wenn Du Bilder hochlädst sind diese ÖFFENTLICH, daher entferne vor dem Hochladen, Metadaten von Deinen Bildern!</b></p>
      {message && <div className="success-message">{message}</div>}
      {error && <div className="error-message">{error}</div>}
      <div className="form-group">
        <label htmlFor="image1">Setup-Image 1:</label>
        <input
          type="file"
          id="image1"
          accept="image/jpeg, image/png, image/jpg"
          onChange={handleImage1Change}
          className="form-control"
        />
      </div>
      <div className="form-group">
        <label htmlFor="image2">Setup-Image 2:</label>
        <input
          type="file"
          id="image2"
          accept="image/jpeg, image/png, image/jpg"
          onChange={handleImage2Change}
          className="form-control"
        />
      </div>
      <button onClick={handleSubmit} disabled={!image1 && !image2} className="btn btn-primary">Upload</button>
    </div>
  );
};

export default ImageUpload;
